import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { FiMail, FiPhone, FiArrowUpRight } from 'react-icons/fi'

const Wrap = styled.footer`
  padding: 0 1.5rem 2rem;

  @media (min-width: 1440px) {
    padding: 0 2rem 2.5rem;
  }
  @media (max-width: 768px) {
    padding: 0 1rem 1.5rem;
  }
`

const Inner = styled.div`
  max-width: var(--container-wide);
  margin: 0 auto;
  background: linear-gradient(160deg, #1b0d12 0%, #3d1f2a 100%);
  color: #fff;
  padding: 4.5rem 3.5rem 2.5rem;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-heavy);

  @media (max-width: 768px) {
    padding: 3rem 1.75rem 2rem;
    border-radius: var(--radius-lg);
  }
  @media (max-width: 520px) {
    padding: 2.25rem 1.5rem 1.5rem;
  }
`

const Top = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr;
  gap: 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(245, 198, 211, 0.18);

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  @media (max-width: 520px) {
    grid-template-columns: 1fr 1fr;
    gap: 1.75rem 1.25rem;
    padding-bottom: 1.75rem;

    & > :first-child {
      grid-column: 1 / -1;
    }
    .legal-col {
      display: none;
    }
  }
`

const Brand = styled.div`
  .logo {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1rem;
    letter-spacing: 0.02em;
  }
  p {
    font-size: 0.92rem;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.7);
    max-width: 320px;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 520px) {
    .logo {
      font-size: 1.3rem;
      margin-bottom: 0.6rem;
    }
    p {
      font-size: 0.85rem;
      line-height: 1.65;
      margin-bottom: 1rem;
    }
  }
  .tag {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.78rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #f5c6d3;
    font-weight: 600;
  }
`

const ColTitle = styled.h5`
  font-size: 0.75rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #f5c6d3;
  font-weight: 700;
  margin-bottom: 1.25rem;

  @media (max-width: 520px) {
    margin-bottom: 0.75rem;
  }
`

const ColList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;

  li a {
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.92rem;
    text-decoration: none;
    transition: color 0.25s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
  }
  li a:hover {
    color: #fff;
  }

  @media (max-width: 520px) {
    gap: 0.55rem;
    li a {
      font-size: 0.86rem;
    }
  }
`

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.75rem;
  gap: 1rem;
  flex-wrap: wrap;

  .copy {
    font-size: 0.82rem;
    color: rgba(255, 255, 255, 0.55);
  }
  .copy .company {
    display: block;
    margin-top: 0.35rem;
  }
  .legal {
    display: flex;
    gap: 1.5rem;
  }
  .legal a {
    font-size: 0.82rem;
    color: rgba(255, 255, 255, 0.65);
    text-decoration: none;
    transition: color 0.25s ease;
  }
  .legal a:hover {
    color: #fff;
  }

  @media (max-width: 520px) {
    padding-top: 1.25rem;
    gap: 0.6rem;
    .copy {
      font-size: 0.75rem;
      line-height: 1.6;
    }
    .legal {
      gap: 1rem;
    }
    .legal a {
      font-size: 0.75rem;
    }
  }
`

const ContactBtns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`

const MailBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-ink);
  background: #fff;
  padding: 0.7rem 1.15rem;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: var(--radius-pill);
  transition: all 0.25s ease;

  &:hover {
    background: var(--color-primary-soft);
    transform: translateY(-1px);
  }
`

const Footer = () => {
  return (
    <Wrap>
      <Inner>
        <Top>
          <Brand>
            <div className='logo'>YUNYUN Tech.</div>
            <p>
              以科技與美感，賦能每一位美業職人。旗艦產品 Beautefeel 美感線上預約平台，
              為美業打造的一站式雲端營運系統。
            </p>
            <ContactBtns>
              <MailBtn href='mailto:service@beautefeel.com'>
                <FiMail /> service@beautefeel.com
              </MailBtn>
              <MailBtn href='tel:+886962023638'>
                <FiPhone /> 0962-023-638
              </MailBtn>
            </ContactBtns>
          </Brand>

          <div>
            <ColTitle>Product</ColTitle>
            <ColList>
              <li>
                <Link to='/services'>Beautefeel 產品</Link>
              </li>
              <li>
                <a
                  href='https://beautefeel.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  前往 Beautefeel <FiArrowUpRight size={12} />
                </a>
              </li>
              <li>
                <Link to='/contact'>預約諮詢</Link>
              </li>
              <li>
                <Link to='/contact'>免費試用</Link>
              </li>
            </ColList>
          </div>

          <div>
            <ColTitle>Company</ColTitle>
            <ColList>
              <li>
                <Link to='/about'>關於雲耘</Link>
              </li>
              <li>
                <Link to='/trends'>美業趨勢</Link>
              </li>
              <li>
                <a
                  href='https://woman.udn.com/woman/story/123163/8600011'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  媒體報導 <FiArrowUpRight size={12} />
                </a>
              </li>
              <li>
                <Link to='/contact'>聯絡我們</Link>
              </li>
            </ColList>
          </div>

          <div className='legal-col'>
            <ColTitle>Legal</ColTitle>
            <ColList>
              <li>
                <Link to='/privacy'>隱私權保護政策</Link>
              </li>
              <li>
                <Link to='/terms'>服務條款</Link>
              </li>
            </ColList>
          </div>
        </Top>

        <Bottom>
          <div className='copy'>
            © {new Date().getFullYear()} YUNYUN Tech. All rights reserved.
            <span className='company'>
              雲耘科技有限公司｜統一編號 00178683
            </span>
          </div>
          <div className='legal'>
            <a
              href='https://beautefeel.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              Beautefeel.com
            </a>
            <Link to='/privacy'>隱私權政策</Link>
            <Link to='/terms'>服務條款</Link>
          </div>
        </Bottom>
      </Inner>
    </Wrap>
  )
}

export default Footer
